import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  background: ${theme.darkRed};
  padding: 40px 0;

  .ant-typography {
    color: ${theme.white};
  }

  .block1 {
    display: flex;
    justify-content: space-between;

    .left-block {
      flex: 1;
      margin-right: 65px;
      .logo-image {
        margin-bottom: 12px;
      }
      .social-block {
        display: none;
      }
    }

    .right-block {
      flex: 2;
      margin-top: 20px;
      .menus-container {
        justify-content: space-between;
        .menu-block {
          .channel-block {
            margin-top: 12px;
            display: flex;
            align-items: center;
            .icon-channel {
              margin-right: 8px;
              display: flex;
              align-items: center;
              svg {
                color: ${theme.white};
                font-size: 20px;
              }
            }
          }

          .menu-ul {
            list-style: none;
            margin: 0;
            padding: 0;
            margin-top: 5px;
            .menu-li {
              display: flex;
              align-items: center;
              padding: 4px 0;
              .icon-menu-block {
                display: flex;
                align-items: center;
                .icon-menu {
                  color: ${theme.white};
                  margin-right: 8px;
                  font-size: 18px;
                  &.icon-phone {
                    transform: scaleX(-1);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .copy-right {
    margin-top: 27px;
    padding-top: 27px;
    border-top: 1px solid ${theme.white};
  }

  .copy-right-mobile {
    display: none;
  }

  .policy-mobile {
    display: none;
  }

  @media (min-width: ${breakpoint.lg}) {
    .ant-col-lg-5 {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .block1 {
      flex-direction: column;
      .left-block {
        margin-right: 30px;
      }
      .right-block {
        .menus-container {
          justify-content: flex-start;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .block1 {
      .left-block {
        flex: 1;

        .social-block {
          display: block;
          .item-social {
            margin-top: 20px;
            svg {
              color: ${theme.white};
              font-size: 25px;
            }
          }
        }
      }
      .right-block {
        flex: 1;
        .menus-container {
          justify-content: flex-start;
        }
      }
    }

    /* .policy-mobile {
      display: block;
      border-top: 1px solid ${theme.white};
      margin-top: 15px;
      padding-top: 15px;
    } */

    .copy-right {
      border-top: none;
    }

    .copy-right-desktop {
      display: none;
    }

    .copy-right-mobile {
      display: block;
      margin-top: 30px;
      padding-top: 0;
      text-align: center;
      border-top: 1px solid ${theme.white};
      margin-top: 20px;
      padding-top: 20px;
    }
  }
`
